import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=61c252fe&"
import script from "./BranchCard.vue?vue&type=script&lang=js&"
export * from "./BranchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports